import { render, staticRenderFns } from "./MessagePreviewModal.vue?vue&type=template&id=4f857aac&scoped=true&"
import script from "./MessagePreviewModal.vue?vue&type=script&lang=js&"
export * from "./MessagePreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./MessagePreviewModal.vue?vue&type=style&index=0&id=4f857aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f857aac",
  null
  
)

export default component.exports